import React from "react";
import Wait from "../wait";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";

export default class UploadBackupPane extends React.Component{


    constructor(props) {
        super(props);

        this.handleChangeFile = this.handleChangeFile.bind(this)
        this.submit = this.submit.bind(this)

    }
    handleChangeFile=e=>{this.setState({ zipped:e.target.files[0] })}

    submit(){
        try{


            const formData = new FormData()
            formData.append('zipped',this.state.zipped)
            formData.append('extra',JSON.stringify({
                project_id:this.props.project.id,
            }))

            Wait.show('Uploading...')
            CreateService.createZIP(formData).then(d=>{
                Wait.dismiss()
                if (d.data.status===0){
                    alert(d.data.message)
                    return
                }
                this.props.loadData()
                PopDetail.dismiss()
            })

        }catch (e) {
             alert(e)
        }
    }


    render() {
        return (<div>
            <input type={'file'} accept=".zip,.ZIP" name={'zipped'} onChange={this.handleChangeFile}/>
            <button className={'btn'} onClick={()=>this.submit()}>
                Submit
            </button>
        </div>)
    }
}